export const backgroundColorClasses = {
  'light-gray': 'bg-www-color-neutral-off-white text-www-color-neutral-medium-dark ',
  'dark-gray': 'bg-www-color-neutral-medium-dark text-www-color-white ',
  'light-green': 'bg-www-color-primary-very-light text-www-color-neutral-medium-dark ',
  'dark-blue-gradient': 'bg-www-color-accent-blue-dark text-www-color-white ',
  'teal-gradient': 'bg-www-color-accent-teal-dark text-www-color-neutral-medium-dark ',
  white: 'bg-www-color-white text-www-color-neutral-medium-dark ',
};
